export default __webpack_public_path__ + "static/media/01.1-cuela.a7b86a0c.png";